export default __webpack_public_path__ + "static/media/client-2.fa4fea5a.png";